<section class="roles-wrapper">
  @if (inspectorRoles.length > 0) {
  <div class="current-role mb-3">
    <h4>الدور الحالى</h4>
    <div class="roles">
      @for (role of inspectorRoles; track role?.role.id) {
      <span>
        {{ role?.role?.name }}
        <img src="assets/images/svg/close.svg" alt="delete-role" (click)="deleteRole(role?.role?.id)" />
      </span>
      }
    </div>
  </div>
  }

  @if(showChooseRole) {
  <div class="choose-role">
    <div class="form-group">
      <label for="" class="form-label">اختر الدور الجديد</label>
      <ng-select bindLabel="name" class="single-select" placeholder="يرجي احتيار الدورالجديد" appendTo="body"
        [(ngModel)]="newRole">
        @for (role of groups; track role.id) {
        <ng-option [value]="role.id">
          {{ role.name }}
        </ng-option>
        }
      </ng-select>
    </div>
    <button class="btn btn-green" (click)="saveNewRole()">
      حفظ
    </button>
  </div>
  } @else {
  <div class="add-role">
    <button class="btn btn-green" (click)="enableChooseRole()">
      <img src="assets/images/svg/plus.svg" alt="add-role" />
      أضف دور {{ inspectorRoles.length > 0 ? ' آخر' : '' }}
    </button>
  </div>
  }
</section>
